import React, { useState } from "react";
import { Form, Col, Row, Button, Table, Container } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import jsDig from "utils/jsDig";
import CustomTooltip from "utils/CustomTooltip";

export default function SemrushIds(props) {
  const [semrushIds, setSemrushIds] = useState(
    jsDig(["semrush", "project_ids"], props.platformData) ? jsDig(["semrush", "project_ids"], props.platformData) : []
  );
  const [semrushEnabled, setSemrushEnabled] = useState(
    jsDig(["semrush", "enabled"], props.platformData) ? jsDig(["semrush", "enabled"], props.platformData) : false
  );
  const websites = [
    jsDig(["primary"], props.websites),
    ...(jsDig(["additional"], props.websites) ? jsDig(["additional"], props.websites) : []).map((website) => website.url),
  ];

  let projectIdImg = require("images/semrush-project-id.jpg");
  projectIdImg = <img  src={`/datapulse${projectIdImg}`} />;
  const tooltipMessage = <div>The ID can change if a new target location has been selected. To make sure the ID is correct, open the project in SEMRush, and in the 'Position Tracking' tile, select 'View full report'. Copy the ID from the URL.<br></br>{projectIdImg}</div>

  const addNewRow = () => {
    //create an object with all of the state fields
    let newRow = {};
    newRow.id = "";
    newRow.label = "";
    newRow.website = jsDig(["websites", "primary"], props) ? jsDig(["websites", "primary"], props) : "";

    setSemrushIds([...semrushIds, newRow]);
  };

  const handleIdDelete = (targetIndex) => {
    let newIds = semrushIds.filter((id, index) => {
      return targetIndex != index;
    });
    setSemrushIds(newIds);
  };

  const handleIdChange = (targetIndex, property, value) => {
    let newIds = semrushIds.map((id, index) => {
      let newId = id;
      if (index == targetIndex) {
        newId[property] = value;
      }
      return newId;
    });
    setSemrushIds(newIds);
  };
  return (
    <>
      <Row className="pb-3 align-items-center">
        <Col xs={"auto"} className="pr-0 pl-0">
          <CustomFormCheck
            sendUncheckedValue
            id="semrush_enabled"
            name="semrush_enabled"
            checked={semrushEnabled}
            label="Enable SEMRush"
            onChange={() => setSemrushEnabled(!semrushEnabled)}
          />
        </Col>
      </Row>
      <Row className="py-3 px-0" style={{ backgroundColor: "#F5F5F5" }}>
        <Col>
          <div className="table-responsive pb-3">
            <Table className="sem-table overflow-hidden">
              <thead>
                <tr>
                  <td className="pl-3 f12 light-primary">Website</td>
                  <td className="pl-3 f12 light-primary">Label</td>
                  <td className="pl-3 f12 light-primary">
                    <span>ID
                      <CustomTooltip
                          faClass="far  fa-question-circle f16 pl-2"
                          message= {tooltipMessage}
                          inline={true}
                        />
                    </span>
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {semrushIds.map((semrushId, index) => {
                  return (
                    <tr key={index}>
                      <td className="pl-0">
                        <Form.Control
                          readOnly={!semrushEnabled}
                          size="sm"
                          as="select"
                          name={`[semrush_ids][][website]`}
                          value={
                            jsDig(["website"], semrushId)
                              ? jsDig(["website"], semrushId)
                              : jsDig(["primary"], props.websites)
                              ? jsDig(["primary"], props.websites)
                              : ""
                          }
                          onChange={(e) => handleIdChange(index, "website", e.target.value)}>
                          <option value="" hidden disabled>
                            Choose one
                          </option>
                          {websites.map((website) => {
                            return (
                              <option key={website} value={website}>
                                {website}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </td>
                      <td>
                        <Form.Control
                          readOnly={!semrushEnabled}
                          size="sm"
                          placeholder="Label"
                          name={`[semrush_ids][][label]`}
                          value={jsDig(["label"], semrushId) ? jsDig(["label"], semrushId) : ""}
                          onChange={(e) => handleIdChange(index, "label", e.target.value)}
                        />
                      </td>
                      <td>
                        <Form.Control
                          readOnly={!semrushEnabled}
                          size="sm"
                          placeholder="ID"
                          name={`[semrush_ids][][id]`}
                          value={jsDig(["id"], semrushId) ? jsDig(["id"], semrushId) : ""}
                          onChange={(e) => handleIdChange(index, "id", e.target.value)}
                        />
                      </td>
                      <td>
                        {index >= 0 && semrushIds.length > 1 && (
                          <i
                            className=" pl-2 fas fa-minus-circle"
                            onClick={(e) => {
                              handleIdDelete(index);
                            }}></i>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div className="text-center text-md-left">
            <Button
              className="mt-3 mb-3 ml-2 mr-4 px-4 py-1"
              size="sm"
              as="input"
              type="button"
              onClick={() => addNewRow()}
              value="+ Add SEMRush Project ID"
              variant="success"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
